const destinations = [
    {
        name: 'Kyoto, Japan',
        image: 'https://images.unsplash.com/photo-1504198453319-5ce911bafcde?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2434&q=80',
        description: 'Get lost in the bamboo forests of Kyoto, Japan'
    },
    {
        name: 'Mainz, Germany',
        image: 'https://images.unsplash.com/photo-1467269204594-9661b134dd2b?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2340&q=80',
        description: 'Collect moments in local the towns of Germany'
    },
    {
        name: 'Malé, Maldives',
        image: 'https://images.unsplash.com/photo-1505881502353-a1986add3762?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2916&q=80',
        description: 'Wake up to a different world in Maldives'
    },
    {
        name: 'Reykjavík, Iceland',
        image: 'https://images.unsplash.com/photo-1518156959312-07a5380c1261?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2302&q=80',
        description: 'Explore the gorgeous landscapes of Iceland'
    },
    {
        name: 'Amalfi, Italy',
        image: 'https://images.unsplash.com/photo-1633321088355-d0f81134ca3b?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2340&q=80',
        description: 'Soak in the view of the Amalfi Coast, Italy'
    },
    {
        name: 'Paris, France',
        image: 'https://images.unsplash.com/photo-1591289009723-aef0a1a8a211?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2340&q=80',
        description: 'Escape the ordinary in the streets of Paris'
    },
    {
        name: 'New York, New York',
        image: 'https://images.unsplash.com/photo-1585238326164-612cb4248873?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2372&q=80',
        description: 'Getaway to the city that never sleeps'
    },
    {
        name: 'Honolulu, Hawaii',
        image: 'https://images.unsplash.com/photo-1542082873-c1d89ae3a6ad?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2340&q=80',
        description: 'Mellow out with the locals in Hawaii'
    },
    {
        name: 'Mykonos, Greece',
        image: 'https://images.unsplash.com/photo-1601581875309-fafbf2d3ed3a?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1974&q=80',
        description: 'Satisfy your wanderlust in Mykonos'
    }
]

export default destinations;